import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Row} from 'reactstrap';

import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';
import { Wrapper, Content , ContentRow} from './ReportsList.styles'

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class ListReports extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.goToView = this.goToView.bind(this);
        this.onGoToCreate = this.onGoToCreate.bind(this);
        this.refreshReports = this.refreshReports.bind(this);
    }

    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onGoToCreate() {
        const dest = this.props.services.currentBaseUrl + 'interactions_creator';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async goToView(row) {
        console.log(row);
        const dest = this.props.services.currentBaseUrl + 'institutions/' + row.rowData.id
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }


    public async goToDownload(row) {
        console.log(row);

        const link = document.createElement('a');
        link.href = row.DownloadLink;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // const dest = this.props.services.currentBaseUrl + 'templates/' + row.rowData.id
        
        // console.log(dest)
    }

    public async refreshReports() {
        const { services: { currentUserID ,fixturesAPI, adminAPI } } = this.props;
        
        const breakdownRes = await adminAPI.genAllReports();
      
        if (breakdownRes.ok) {
          toast.success("Reports regenerating")
          
        }

        else {
            toast.error("Request failed")
        }
        
    }


    public customTD = props =>{
        return (
          <td>
            {/*tslint:disable-next-line jsx-no-lambda*/}
            <a href={props.rowData.DownloadLink} download={true}>Click to download</a>
            
          </td>
        );
    } 

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;


        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const messagesDataKey = ["id", "UserName", "ReportType", "Assessment", "Created", "download"];
        
        const messagesThead = ["ID", "User", "Type", "Assessment",  "Created", "Action"];

        const messagesRes = await adminAPI.getReports();

        if (messagesRes.ok) {
            
            const messages = messagesRes.data.reports;

            this.setState(
                {
                     data: {
                        messages,
                        loaded: true,
                        messagesDataKey,
                        messagesThead
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>

                <Button onClick={this.refreshReports}  style={{marginLeft: "5px"}}>Refresh All Reports</Button>
              </Content>

              <Content>
                <SortableTbl
                    tblData={data.messages}
                    tHead={data.messagesThead}
                    dKey={data.messagesDataKey}
                    defaultCSS={false}
                    customTd={[
                        { custd: this.customTD, keyItem: "download", sortable: false }
                    ]}
                />

              </Content>
              
              </Wrapper>
        );

    }

}

export default withServices(ListReports);


// WEBPACK FOOTER //
// ./src/pages/Admin/Reports/ReportsList/ReportsList.tsx